import React from "react";
import { Menu, Layout, Divider, Button } from "antd";
import {
  UserOutlined,
  NotificationOutlined,
  HomeOutlined,
  TableOutlined,
  ContactsOutlined,
  SyncOutlined,
  FileTextOutlined,
  LogoutOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import {
  CircleQuestionMark,
  FolderClock,
  NotebookText,
  Grid3x3,
  FilePlus,
  CalendarDays,
  CalendarSync,
  BicepsFlexed,
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import useUsuario from "../../../core/hooks/UseUsuario";
import { RoundButton } from "../../components/RoundButton/RoundButton";
import { Resolucao } from "../../../sdk/@types";
import { Footer } from "antd/es/layout/layout";

const { Sider } = Layout;
const { SubMenu } = Menu;

interface SidebarProps {
  questions? : Resolucao.ResolucaoQuestao[]
  collapsed?: boolean;
  onClickLeft?: () => void;
  onClickRight?: () => void;
}

export default function SimuladoFooter({ collapsed, questions, onClickLeft, onClickRight }: SidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const { usuario } = useUsuario();

  return (
    <Footer
      className="bg-navy"
      // filho de um flex column: sem isto o rodapé é espremido quando a
      // questão é alta, em vez de manter a sua altura e deixar o miolo rolar
      style={{ flexShrink: 0 }}
    >
      <div className="flex flex-row items-center justify-between mt-6">
        <Button  
          size="large" 
          icon={<ArrowLeftOutlined />} 
          onClick={onClickLeft}
          className="ml-20" >Anterior</Button>

        <Button  
          size="large" 
          icon={<ArrowRightOutlined />} 
          className="font-bold" 
          onClick={onClickRight}
          type="primary">Avançar</Button>
      </div>
    </Footer>
  );
}
